import { render, staticRenderFns } from "./ShowBankName.vue?vue&type=template&id=657ec82e&scoped=true&"
import script from "./ShowBankName.vue?vue&type=script&lang=ts&"
export * from "./ShowBankName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657ec82e",
  null
  
)

export default component.exports